import React from 'react'

export function FlexTable({ children, style }) {
  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'column nowrap',
        lineHeight: 1.5,
        borderBottom: '1px solid #d0d0d0',
        flex: '1 1 auto',
        ...style
      }}
    >
      {children}
    </div>
  )
}

export function FlexRow({ children, style, onClick }) {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexFlow: 'row nowrap',
        ...style
      }}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export function FlexTitleRow({ children, style, onClick }) {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexFlow: 'row nowrap',
        justifyContent: 'center',
        ...style
      }}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export function FlexColumn({ children, style, onClick }) {
  return (
    <div
      style={{
        display: 'flex',
        flexFlow: 'row nowrap',
        flexGrow: 1,
        flexBasis: 0,
        padding: '0.5em',
        wordBreak: 'break-word',
        overFlow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '0px',
        alignItems: 'center',
        ...style
      }}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
